module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-container"
  }, [(_vm.user.isAdded) ? _c('button', {
    staticClass: "is-added",
    on: {
      "click": _vm.removeOfList
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")])]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "hidden": "",
      "id": ("user-" + (_vm.user.id)),
      "name": "user-selector",
      "type": "radio",
      "disabled": _vm.user.isOnlyRead
    },
    domProps: {
      "value": _vm.user
    },
    on: {
      "change": function($event) {
        _vm.radioOnChange(_vm.user)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "user-selector",
    class: {
      'disabled': _vm.user.isOnlyRead
    },
    attrs: {
      "for": ("user-" + (_vm.user.id))
    }
  }, [_c('span', {
    staticClass: "user-avatar"
  }, [_c('img', {
    attrs: {
      "alt": _vm.user.name,
      "src": _vm.user.url_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-data"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.name) + " " + _vm._s(_vm.user.lastname))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.user.quantity_rooms) ? _c('span', {
    staticClass: "user-assignments"
  }, [_vm._v(_vm._s(_vm.user.quantity_rooms) + " mucamas")]) : _vm._e(), _vm._v(" "), (_vm.user.room_assigned >= 0) ? _c('span', {
    staticClass: "user-assignments"
  }, [_vm._v(_vm._s(_vm.user.room_assigned) + " habitaciones")]) : _vm._e()])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56694285","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/UserSelector.vue
// module id = 745
// module chunks = 108